import withConfigTransport from '../../../../services/config-transport/withConfigTransport'
import _VaTreeNode from './VaTreeNode.vue'

export const VaTreeNode = withConfigTransport(_VaTreeNode)
